<template>
  <div class="w-full overflow-x-auto border border-[#d8d8e2] rounded-lg">
    <table class="w-full min-w-[900px] border-collapse">
      <thead>
        <tr class="bg-[#f0f0f4]">
          <th
            v-for="col in columns"
            :key="col"
            class="px-4 py-2.5 text-sm font-bold text-[#272735] text-center"
          >
            {{ col }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="n in 5" :key="n" class="border-t border-[#e8e8ed] bg-white animate-pulse">
          <td class="px-4 py-3">
            <div class="flex items-center gap-3">
              <div class="shrink-0 w-10 h-10 rounded-full bg-slate-200" />
              <div class="flex flex-col gap-1">
                <div class="h-3.5 w-28 bg-slate-200 rounded" />
                <div class="h-3 w-20 bg-slate-200 rounded" />
              </div>
            </div>
          </td>
          <td class="px-4 py-3">
            <div class="flex flex-col gap-1">
              <div class="h-3.5 w-24 bg-slate-200 rounded" />
              <div class="h-3 w-32 bg-slate-200 rounded" />
            </div>
          </td>
          <td class="px-4 py-3">
            <div class="flex flex-col items-center gap-1">
              <div class="h-3.5 w-20 bg-slate-200 rounded" />
              <div class="h-3 w-24 bg-slate-200 rounded" />
            </div>
          </td>
          <td class="px-4 py-3">
            <div class="flex justify-center">
              <div class="h-6 w-20 bg-slate-200 rounded-full" />
            </div>
          </td>
          <td class="px-4 py-3">
            <div class="flex justify-center">
              <div class="h-8 w-20 bg-slate-200 rounded" />
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script setup lang="ts">
const columns = ['Médico', 'Escala', 'Data de envio', 'Status', 'Ações']
</script>
